export type SettingsTab = "amazon" | "workspace";

export type SettingsTabSearch =
  | SettingsTab
  | "amazon-ads"
  | "seller-central"
  | "members"
  | undefined;

/**
 * Keep legacy links working: the Amazon surfaces were consolidated into one tab,
 * and the members tab was removed with the main/sub-account model (ADP-167) —
 * old `?tab=members` links land on the workspace tab.
 */
export function normalizeSettingsTab(tab: SettingsTabSearch): SettingsTab {
  if (tab === "workspace" || tab === "members") return "workspace";
  return "amazon";
}
